export default class Slider {

    constructor (slider) {
        this.initSlider(slider);
    }

    initSlider (slider) {
        this.sliderItems = [...slider.querySelectorAll('[data-slider="image"]')];
        this.currentIndex = 0;
        this.slider = slider;

        this.resetSlider();
        this.bindEvents();
    }

    bindEvents () {
        addEventListener('resize', () => {
            this.resetSlider();
        });

        this.sliderItems.forEach((el) => {
            this.addClickEvent(el);
        });
        this.addKeyDownEvent();
    }

    addKeyDownEvent() {
        addEventListener('keydown', (e) => {

            if (e.keyCode === 37) {

                this.currentIndex <= 0 ?
                    this.currentIndex = this.currentIndex :
                    this.currentIndex = --this.currentIndex;

                this.makeActiveImage(this.currentIndex);

            } else if (e.keyCode === 39) {

                this.currentIndex >= (this.sliderItems.length - 1) ?
                    this.currentIndex = this.currentIndex :
                    this.currentIndex = ++this.currentIndex;

                this.makeActiveImage(this.currentIndex);

            }
        });
    }

    addClickEvent (el) {
        el.addEventListener ('click', (e) => {
            this.currentIndex = el.dataset.index;
            this.makeActiveImage(this.currentIndex);
        });
    }

    makeActiveImage (elIndex) {
        const el = this.sliderItems[elIndex];
        let vpCenter = window.innerWidth / 2;
        let offset = (elIndex * el.offsetWidth) - (vpCenter - (el.offsetWidth /  2));

        offset < 0 ?
            this.slider.style.transform = `translate3d(${-offset}px,0,0)` :
            this.slider.style.transform = `translate3d(-${offset}px,0,0)`;

        this.sliderItems.map(this.resetActiveState());
        el.classList.add('is-active');
    }

    resetActiveState () {
        return (el) => {
            el.classList.remove('is-active');
            return el;
        };
    }

    resetSlider () {
        const el = this.sliderItems[0];
        const initOffset = (window.innerWidth / 2) - (el.offsetWidth /  2);
        this.slider.style.transform = `translate3d(${initOffset}px,0,0)`;

        if (el.dataset.index === "0") {
            el.classList.add('is-active');
        }
    }
}



// WEBPACK FOOTER //
// ./lib/slider.js